import { ReactNode } from 'react'

import {
  Box,
  BoxProps,
  Divider,
  Heading,
  useStyleConfig,
} from '@chakra-ui/react'

import { PropsWithChildrenRequired } from 'constants/typings'

export interface CardProps extends BoxProps {
  variant?: string
  title?: string
  header?: ReactNode
  contentBoxProps?: BoxProps
}

export const Card = ({
  children,
  variant = 'layout',
  header,
  title,
  contentBoxProps,
  ...rest
}: PropsWithChildrenRequired<CardProps>) => {
  const styles = useStyleConfig('Card', { variant })

  return (
    <Box __css={styles} {...rest}>
      {header || title ? (
        <>
          {header ||
            (title && (
              <Box>
                <Heading as="h5" size="sm" mx="32px" my="24px">
                  {title}
                </Heading>
              </Box>
            ))}
          <Divider />
        </>
      ) : null}
      <Box mx="32px" my="24px" {...contentBoxProps}>
        {children}
      </Box>
    </Box>
  )
}
